import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import _ from "lodash";

import { COLORS } from "constant";
import DashboardCreateSelectSensorModal from "components/dashboard/create/modal/SelectDevices";
import {
    ColorPicker,
    useCreateDashboardStore,
} from "components/dashboard/create";
import ChartList from "./ChartList";
import "./styles.css";

const CreateCombinedSensorsChart = ({
    onChange,
    isUpdate,
    panel,
    gatewayIds,
}: any) => {
    const sensorType = "People Count Sensor";
    const defaultChartName = "People Count";
    const errorMessage =
        "Please select at least 2 sensors to create a combined chart.";

    const [showSelectSensorModal, setShowSelectSensorModal] = useState(false);
    const [error, setError] = useState("");
    const [sensorList, setSensorList] = useState<any[] | null>(
        isUpdate ? null : []
    );
    const [chartColor, setChartColor] = useState(
        isUpdate ? _.get(panel, "attributes[0].color") : COLORS[0]
    );
    const [chartName, setChartName] = useState(
        isUpdate ? panel.name : defaultChartName
    );

    const { deviceList } = useCreateDashboardStore();

    /**
     * Get the list of sensors based on the gateways, just for update case
     */
    useEffect(() => {
        if (
            deviceList.length &&
            isUpdate &&
            !sensorList &&
            gatewayIds?.length
        ) {
            const sensors = (gatewayIds || []).map((gatewayId: string) => {
                return deviceList.find(
                    (device: any) => device.gatewayId === gatewayId
                );
            });

            setSensorList(sensors);
        }
    }, [deviceList, isUpdate, sensorList, gatewayIds]);

    useEffect(() => {
        if (typeof onChange === "function" && sensorList !== null) {
            const changeData: any = {
                chartName,
                chartColor,
                sensorList,
            };

            onChange(changeData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chartName, chartColor, sensorList]);

    const handleSelectSensor = (selectedSensors: any) => {
        const selectedSensor = Object.values(selectedSensors) as any;
        if (!selectedSensor) {
            return;
        }

        setSensorList(selectedSensor);

        const error = selectedSensor.length < 2 ? errorMessage : "";
        setError(error);
    };

    if (isUpdate && !deviceList) {
        return <></>;
    }

    return (
        <div className="create-pcs-chart-form">
            <Form.Group className="mt-4">
                <Form.Label>Chart Name</Form.Label>
                <Form.Control
                    name="name"
                    type="text"
                    value={chartName}
                    placeholder=""
                    onChange={(event) => setChartName(event.target.value)}
                />
            </Form.Group>

            <Form.Group className="mt-4">
                <Form.Label>Color</Form.Label>
                <ColorPicker
                    defaultValue={chartColor}
                    onChange={(_, color) => {
                        setChartColor(color);
                    }}
                />
            </Form.Group>

            <p>Sensors for combined people count chart</p>

            <Button
                variant="primary"
                onClick={() => {
                    setShowSelectSensorModal(true);
                }}
            >
                Select Sensors
            </Button>

            {error ? (
                <p style={{ color: "#F2495E", marginTop: 10, fontSize: 14 }}>
                    {error}
                </p>
            ) : (
                ""
            )}

            <ChartList
                sensorList={sensorList}
                onChange={(newSensors: any) => {
                    setSensorList(newSensors);

                    const error = newSensors.length < 2 ? errorMessage : "";
                    setError(error);
                }}
            />

            <DashboardCreateSelectSensorModal
                allowSensorFilter={false}
                show={showSelectSensorModal}
                values={(sensorList ?? []).pluck("device_id")}
                deviceType="Sensor"
                sensorTypes={[sensorType]}
                onHide={() => setShowSelectSensorModal(false)}
                onSave={(_event, data) => handleSelectSensor(data)}
            />
        </div>
    );
};

export default CreateCombinedSensorsChart;
